/**
 * @flow
 */

import {
  ON_PAYMENT_PLAN_MOUNT,
  ON_PAYMENT_PLAN_MOUNT_SUCCESS,
  PAY_INSTALLMENT,
  PAY_INSTALLMENT_SUCCESS,
  PAY_INSTALLMENT_ERROR,
  PAY_INSTALLMENTS,
  PAY_INSTALLMENTS_SUCCESS,
  PAY_INSTALLMENTS_ERROR
} from './actions';

import {
  UPDATE_CREDIT_CARD,
  UPDATE_CREDIT_CARD_SUCCESS,
  UPDATE_CREDIT_CARD_ERROR
} from '../stripe/actions';

import { TOGGLE_PAY_INSTALLMENT_MODAL } from '../modal/actions';

const initialState = {
  isLoading: false,
  openedInstallmentNumber: -1,
  id: null,
  data: {}
};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {

    case ON_PAYMENT_PLAN_MOUNT:
      return Object.assign({}, state, {
        isLoading: true,
        id: action.payload.id
      });

    case ON_PAYMENT_PLAN_MOUNT_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        data: action.payload
      });

    case PAY_INSTALLMENT:
      return Object.assign({}, state, {
        isLoading: true
      });

    case PAY_INSTALLMENT_SUCCESS:
      return Object.assign({}, state, {
        data: action.payload,
        isLoading: false
      });

    case PAY_INSTALLMENT_ERROR:
      return Object.assign({}, state, {
        isLoading: false
      });

    case PAY_INSTALLMENTS:
      return Object.assign({}, state, {
        isLoading: true
      });

    case PAY_INSTALLMENTS_SUCCESS:
      return Object.assign({}, state, {
        data: action.payload,
        isLoading: false
      });

    case PAY_INSTALLMENTS_ERROR:
      return Object.assign({}, state, {
        isLoading: false
      });

    case UPDATE_CREDIT_CARD:
      return Object.assign({}, state, {
        isLoading: true
      });

    case UPDATE_CREDIT_CARD_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        data: action.payload
      });

    case UPDATE_CREDIT_CARD_ERROR:
      return Object.assign({}, state, {
        isLoading: false
      });

    case TOGGLE_PAY_INSTALLMENT_MODAL:
      return Object.assign({}, state, {
        openedInstallmentNumber: action.payload.number ? action.payload.number : -1
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/payment-plans/reducer.js